import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../states/dashboard-state';

export const avcDashboard = createFeatureSelector<State>('avc_dashboard');

export const selectCurrentKpis = createSelector(avcDashboard, (state: State) => state?.currentKps);

export const selectPreviousKpis = createSelector(avcDashboard, (state: State) => state?.previouseYearKps);

export const selectStatisticsFilters = createSelector(avcDashboard, (state: State) => state?.statisticFilter);

export const selectTopRates = createSelector(avcDashboard, (state: State) => state?.topRates);

export const selectSubTopRatesHotel = createSelector(avcDashboard, (state: State) => state?.subTopRatesHotel);

export const selectSubTopRatesCity = createSelector(avcDashboard, (state: State) => state?.subTopRatesCity);

export const selectAllOfficeIds = createSelector(avcDashboard, (state: State) => state?.allOfficeIds);

export const selectCurrentChart = createSelector(avcDashboard, (state: State) => state?.currentStatistics);

export const selectOneYearAgoChart = createSelector(avcDashboard, (state: State) => state?.oneYearAgoStatistics);

export const selectTwoYearsAgoChart = createSelector(avcDashboard, (state: State) => state?.twoYearsAgoStatistics);

export const isCurrentChartEmpty = createSelector(avcDashboard, (state: State) => !state?.currentStatistics);

export const isOneYearAgoChartEmpty = createSelector(avcDashboard, (state: State) => !state?.oneYearAgoStatistics);

export const isTwoYearsAgoChartEmpty = createSelector(avcDashboard, (state: State) => !state?.twoYearsAgoStatistics);

export const isLoading = createSelector(
  avcDashboard,
  (state: State) =>
    state?.currentStatisticsLoading ||
    state?.oneYearAgoStatisticsLoading ||
    state?.twoYearsAgoStatisticsLoading ||
    state?.topRatesLoading
);

export const subTopRatesLoading = createSelector(
  avcDashboard,
  (state: State) => state?.subTopRatesCityLoading || state?.subTopRatesHotelLoading
);

export const isOfficesRequestSending = createSelector(avcDashboard, (state: State) => state?.officesRequestSending);

